import { copyTextToClipboard } from "src/domains/shared/utils/copyTextToClipboard";

export type SharePageOutcome = "shared" | "copied" | "dismissed" | "failed";

export interface SharePageTarget {
  title: string;
  url: string;
}

/** 사용자가 공유 창을 닫은(취소한) 예외 — 알림 없이 끝낸다 */
const SHARE_ABORT_ERROR_NAME = "AbortError";

type ShareCapable = Partial<Pick<Navigator, "share">>;

/**
 * 지금 페이지를 공유한다(marketing-site-shell 「머리말 구성」): 기기 공유 창(Web Share)이 있으면 그것을 열고, 없거나
 * 열지 못하면 주소를 클립보드에 복사한다. 취소는 `dismissed`, 복사까지 안 되면 `failed` — 알림은 호출자가 띄운다.
 */
export async function sharePage(
  target: SharePageTarget,
  nav: ShareCapable = navigator
): Promise<SharePageOutcome> {
  if (typeof nav.share === "function") {
    try {
      await nav.share(target);
      return "shared";
    } catch (error) {
      if (error instanceof Error && error.name === SHARE_ABORT_ERROR_NAME) {
        return "dismissed";
      }
    }
  }
  return (await copyTextToClipboard(target.url)) ? "copied" : "failed";
}
